<template>
  <section class="modal-card active-content-removal-modal">
    <header class="modal-card-head active-content-removal-modal__header">
      <div class="active-content-removal-modal__heading">
        <span class="active-content-removal-modal__icon" aria-hidden="true">
          <i class="fas fa-exclamation-triangle"></i>
        </span>
        <p class="modal-card-title">{{ dialogTitle }}</p>
      </div>
      <button
        type="button"
        class="delete"
        aria-label="Annuler et fermer"
        @click="$emit('close')"
      ></button>
    </header>

    <section class="modal-card-body active-content-removal-modal__body">
      <p>
        Que souhaitez-vous faire de {{ contentLabel }}<template v-if="title"> « {{ title }} »</template> ?
      </p>
      <p class="active-content-removal-modal__hint">
        La désactivation retire le contenu de l’application sans effacer ses données.
        La suppression définitive est irréversible.
      </p>
    </section>

    <footer class="modal-card-foot active-content-removal-modal__actions">
      <button
        type="button"
        class="active-content-removal-modal__button active-content-removal-modal__button--cancel"
        @click="$emit('close')"
      >
        Annuler
      </button>
      <button
        type="button"
        class="active-content-removal-modal__button active-content-removal-modal__button--disable"
        @click="$emit('disable')"
      >
        Désactiver
      </button>
      <button
        type="button"
        class="active-content-removal-modal__button active-content-removal-modal__button--delete"
        @click="$emit('delete')"
      >
        Supprimer définitivement
      </button>
    </footer>
  </section>
</template>

<script>
export default {
  name: 'ActiveContentRemovalModal',
  props: {
    title: {
      type: String,
      default: ''
    },
    contentType: {
      type: String,
      default: 'content',
      validator: value => ['article', 'survey', 'document', 'content'].includes(value)
    }
  },
  emits: ['close', 'disable', 'delete'],
  computed: {
    contentLabel () {
      return {
        article: 'cette actualité',
        survey: 'ce sondage',
        document: 'ce document',
        content: 'ce contenu'
      }[this.contentType]
    },
    dialogTitle () {
      return {
        article: 'Retirer cette actualité ?',
        survey: 'Retirer ce sondage ?',
        document: 'Retirer ce document ?',
        content: 'Retirer ce contenu ?'
      }[this.contentType]
    }
  }
}
</script>

<style lang="scss" scoped>
.active-content-removal-modal {
  width: 600px;
  max-width: calc(100vw - 2rem);
  overflow: hidden;
  border-radius: 0.75rem;
}

.active-content-removal-modal__header {
  align-items: center;
  background: #fff;
}

.active-content-removal-modal__heading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.active-content-removal-modal__icon {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  color: #c2410c;
  background: #ffedd5;
  border-radius: 999px;
}

.active-content-removal-modal__body {
  color: #374151;
  line-height: 1.5;
}

.active-content-removal-modal__hint {
  margin-top: 0.75rem;
  color: #6b7280;
  font-size: 0.9rem;
}

.active-content-removal-modal__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.75rem;
  background: #f8fafc;
}

.active-content-removal-modal__button {
  min-height: 2.5rem;
  padding: 0.55rem 1rem;
  border: 1px solid transparent;
  border-radius: 0.375rem;
  font-weight: 600;
  line-height: 1.2;
  transition: background-color 150ms ease, border-color 150ms ease;
}

.active-content-removal-modal__button:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.active-content-removal-modal__button--cancel {
  color: #374151;
  background: #fff;
  border-color: #d1d5db;
}

.active-content-removal-modal__button--cancel:hover {
  background: #f3f4f6;
}

.active-content-removal-modal__button--disable {
  color: #fff;
  background: #f97316;
  border-color: #f97316;
}

.active-content-removal-modal__button--disable:hover {
  background: #ea580c;
  border-color: #ea580c;
}

.active-content-removal-modal__button--delete {
  color: #fff;
  background: #dc2626;
  border-color: #dc2626;
}

.active-content-removal-modal__button--delete:hover {
  background: #b91c1c;
  border-color: #b91c1c;
}

@media (max-width: 640px) {
  .active-content-removal-modal__actions {
    align-items: stretch;
    flex-direction: column;
  }

  .active-content-removal-modal__button {
    width: 100%;
  }
}
</style>
